import { Fragment } from "react";

// Renders a plain agreement string, turning **double-asterisk** spans into bold
// <strong> text. Everything else is left as-is, so the surrounding element's
// `white-space: pre-line` still preserves \n line breaks and \n\n blank lines.
//
// Usage in the content file (agreementContent.js):
//   "**1. Ümumi müddəalar** \n" +
//   "\n" +
//   "1.1. Hazırkı **Razılaşma** ... \n"
//
// Only ** ** is supported (bold). It can appear anywhere in a line; a lone ** with
// no closing pair is left as literal text.
export default function RichText({ text }) {
  // Split on **...**, capturing the inner text. With a capture group, split keeps
  // the captured bold spans, which land at the ODD indices of the result.
  const parts = String(text).split(/\*\*([\s\S]+?)\*\*/g);
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <strong key={i}>{part}</strong>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        )
      )}
    </>
  );
}
